/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LabelPrintMode {
  None = 'None',
  PrePrint = 'PrePrint',
  Print = 'Print',
  RePrint = 'RePrint'
}
